import { createAction } from 'redux-actions';

import types from './types';

const _selectStore = createAction(types.SELECT_STORE);
const selectStore = id => _selectStore({ id });

const setStoredAddress = createAction(types.SET_STORED_ADDRESS);

const setDeliveryMode = createAction(types.SET_DELIVERY_MODE);

const putDeliveryAddress = createAction(types.PUT_DELIVERY_ADDRESS);

const setDeliveryTimeSlots = createAction(types.SET_DELIVERY_TIME_SLOTS);

const setShippingBlocked = createAction(types.SHIPPING_BLOCKED);
const deliveryAddressError = createAction(types.DELIVERY_ADDRESS_ERROR);
const setChangeDeliveryAddress = createAction(types.SET_CHANGE_DELIVERY_ADDRESS);
const checkDeliveryAddress = createAction(types.CHECK_DELIVERY_ADDRESS);

const sagaSetAddressForBilling = createAction(types.SAGA_SET_ADDRESS_FOR_BILLING);
const setAddressForBilling = createAction(types.SET_ADDRESS_FOR_BILLING);
const setUseDeliveryAsBilling = createAction(types.SET_USE_DELIVERY_AS_BILLING);
const setProgressBarId = createAction(types.SET_PROGRESS_BAR_ID);
const emptyDeliveryAddress = createAction(types.EMPTY_DELIVERY_ADDRESS);
const hideDeliveryAddress = createAction(types.HIDE_DELIVERY_ADDRESS);
const closeShippingCountdown = createAction(types.HIDE_SHIPPING_COUNTDOWN);
const showShippingCountdown = createAction(types.SHOW_SHIPPING_COUNTDOWN);
const showCustomErrorMessage = createAction(types.SHOW_CUSTOM_ERROR_MESSAGE);

export default {
    selectStore,
    setStoredAddress,
    setDeliveryTimeSlots,
    setShippingBlocked,
    setDeliveryMode,
    setProgressBarId,
    putDeliveryAddress,
    deliveryAddressError,
    setChangeDeliveryAddress,
    checkDeliveryAddress,
    sagaSetAddressForBilling,
    setAddressForBilling,
    setUseDeliveryAsBilling,
    emptyDeliveryAddress,
    hideDeliveryAddress,
    closeShippingCountdown,
    showShippingCountdown,
    showCustomErrorMessage,
};
